import { Formik, Form } from "formik";
import "./style.scss";
import { Checkbox, Spinner } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { useConfigureFooter } from "~hooks/useHelpers";
import useSynchronizeForm from "./hooks/useSynchronizeForm";
import useSincronizacao from "~/fetchs/useSincronizacao";

const SynchronizePage = () => {
  const [showSubmit, setShowSubmit] = useState(false);
  const formikRef = useRef(null);

  useConfigureFooter(
    {
      form: showSubmit,
      submitLabel: "Sincronizar",
      formId: "synchronize-form",
    },
    [showSubmit],
  );

  const [listChecks, setListChecks] = useState({
    trilhas: false,
    canaisDistribuicao: false,
    cidades: false,
    contexto: false,
    embalagens: false,
    empresas: false,
    estados: false,
    familiaProdutos: false,
    filiais: false,
    grupoCentralizador: false,
    grupoProdutos: false,
    grupoSegmento: false,
    local: false,
    prazoPagamento: false,
    precosCliente: false,
    tabelaPreco: false,
    produtos: false,
    produtosFiliais: false,
    segmento: false,
    servico: false,
    simulacoes: false,
    tipoCondicao: false,
    cep: false,
    hierarquiasAprovacao: false,
    unidadeMedidas: false,
    motivos: false,
    parametros: false,
    pesquisaCanalDistribuicao: false,
    pesquisaGrupoMaterialCanalDistribuicao: false,
    pesquisaMedidas: false,
    pesquisaPlayers: false,
    pesquisaGrupoMaterialPlayer: false,
    pesquisaPrazos: false,
    pesquisaGrupoMaterialPrazo: false,
    pesquisaProdutos: false,
    pesquisaGrupoMaterial: false,
    pesquisaEmbalagem: false,
  });

  const { sincronismos, setSincronismos, loading, refetchings } = useSincronizacao(false);

  const { handleCheck, handleCheckAll, checkAll, handleSubmit } = useSynchronizeForm({
    setShowSubmit,
    formikRef,
    listChecks,
    setListChecks,
    sincronismos,
    setSincronismos,
    loading,
    refetchings,
  });

  const formatDate = (date) => {
    // Obtenha as partes da data
    let day = date.getDate();
    let month = date.getMonth() + 1; // Janeiro é 0!
    let year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();

    // Adicione zeros à esquerda se necessário
    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;

    // Formate a string no formato "d/m/y h:m"
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <main className="synchronize-page">
      <div className="container content">
        <h2 className="title">Sincronizar Dadosssss</h2>
        {loading ? (
          <div className="loading-container">
            <Spinner size={"xl"} thickness="4px" />
          </div>
        ) : (
          <Formik initialValues={{}} onSubmit={(values) => handleSubmit(values)} innerRef={formikRef}>
            {() => (
              <Form id="synchronize-form">
                <div className="top-row">
                  <label className="select-all">
                    <Checkbox onChange={handleCheckAll} isChecked={checkAll} />
                    <span className="desc">Selecionar todos</span>
                  </label>
                </div>

                <div className="cards-container">
                  {sincronismos.map((check, index) => (
                    <label key={index} className={`card ${check.checked ? "checked" : ""}`}>
                      <div className="check-row">
                        <Checkbox
                          name="synchronize"
                          value={check.table}
                          onChange={(e) => handleCheck(e, check, index)}
                          isChecked={check.checked}
                        />
                        <span className="desc">{check.nome}</span>
                      </div>

                      <div className="bottom-row">
                        <span className="registers">{check.quantidade} registros</span>

                        {check.data && (
                          <span className="timestamp">{check.data ? formatDate(new Date(check.data)) : ""}</span>
                        )}
                      </div>
                    </label>
                  ))}
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </main>
  );
};

export default SynchronizePage;
